import api from '@/services/Api'
import { RepairFile } from '@/models/RepairFile';
import { auth as $store } from '@/store/AuthModule'

class RepairFileService {
  async create(data) {
    if (data instanceof FormData) {
      const response = await api.post(
        '/distributor/repair-file/create',
        data,
        {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } else {
      const response = await api.post(
        '/distributor/repair-file/create',
        data)
      return response.data
    }
  }

  async createGeneric(data) {
    const response = await api.post(
      '/distributor/generic-repair-file/create',
      data)
    return response.data
  }

  async update(repairFileId, data) {
    if (data instanceof FormData) {
      const response = await api.put(
        '/distributor/repair-file/update/' + repairFileId,
        data,
        {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } else {
      const response = await api.put(
        '/distributor/repair-file/update/' + repairFileId,
        data)
      return response.data
    }
  }

  async get(repairFileBoomerangId) {
    const response = await api.get(
      '/distributor/repair-file/' + repairFileBoomerangId)
    return new RepairFile(
      response.data.technical_id,
      response.data.boomerang_id,
      response.data.folder_type,
      response.data.internal_command_number,

      response.data.step,
      response.data.status_macro,
      response.data.status_detail,
      response.data.status_guarantee,

      response.data.requestor_account_email,
      response.data.requestor_collaborator_fullname,

      response.data.lastname,
      response.data.email,
      response.data.phone_number,
      response.data.company,

      response.data.network_name,
      response.data.network_boomerang_id,

      response.data.store_name,
      response.data.store_boomerang_id,

      response.data.manufacturer_name,
      response.data.manufacturer_boomerang_id,
      response.data.manufacturer_boomerang_full_support,

      response.data.category_name,
      response.data.category_boomerang_id,
      response.data.sub_category_name,
      response.data.sub_category_boomerang_id,

      response.data.product_boomerang_id,
      response.data.product_name,
      response.data.product_picture,

      response.data.product_manufacturer_name,
      response.data.product_manufacturer_name_ref,
      response.data.product_manufacturer_code_ref,

      response.data.product_network_code_ref,
      response.data.product_manufacturer_id_bdd,
      response.data.product_description,
      response.data.product_reparable,
      response.data.product_folder_workflow,
      response.data.product_repair_time,
      response.data.product_new_price,
      response.data.product_new_price_date,
      response.data.product_amount_repair_fund,
      response.data.product_returnable,
      response.data.product_length,
      response.data.product_height,
      response.data.product_width,
      response.data.product_weight,
      response.data.product_repair_end_date,
      response.data.product_selling_end_date,
      response.data.product_comment,
      response.data.product_type,

      response.data.product_asbestos_answer,
      response.data.product_asbestos_proof_needed,
      response.data.product_asbestos_proof_file_path,
      response.data.product_asbestos_proof_file_path_aws,

      response.data.product_buy_date,
      response.data.product_buy_proof_needed,
      response.data.product_buy_proof_file_path,
      response.data.product_buy_proof_file_path_aws,

      response.data.product_guarantee_extension_date,
      response.data.product_guarantee_extension_proof_needed,
      response.data.product_guarantee_extension_proof_file_path,
      response.data.product_guarantee_extension_proof_file_path_aws,

      response.data.product_force_support_description,
      response.data.product_force_support_proof_needed,
      response.data.product_force_support_proof_file_path,
      response.data.product_force_support_proof_file_path_aws,

      response.data.product_commercial_guarantee,
      response.data.product_extension_guarantee,
      response.data.product_repair_extension_guarantee,
      response.data.product_serial_number,

      response.data.takeover_product_status,
      response.data.takeover_repairer_total_cost,
      response.data.takeover_client_price,
      response.data.takeover_transport_cost,
      response.data.takeover_additional_cost,
      response.data.takeover_client_total_cost,

      response.data.takeover_product_replacement_name,
      response.data.takeover_product_replacement_boomerang_id,

      response.data.takeover_billing_number,

      response.data.breakdown_description,
      response.data.breakdown_type,
      response.data.breakdown_type_boomerang_id,

      response.data.repairer_estimate_pricing_type,
      response.data.initial_pricing_type,

      response.data.package_boomerang_id,
      response.data.package_code,
      response.data.package_type,
      response.data.package_client_price,
      response.data.package_repairer_cost_code,
      response.data.package_repairer_cost_value,
      response.data.package_network_code,
      response.data.package_designation,
      response.data.package_frns_billing_code,
      response.data.package_frns_designation,
      response.data.package_discount_rate,
      response.data.package_catalog_value,

      response.data.packet_weight,
      response.data.packet_length,
      response.data.packet_height,
      response.data.packet_width,
      response.data.packet_battery_voltage,
      response.data.packet_battery_amperage,
      response.data.packet_battery_watt_hour,
      response.data.express_check_box,

      response.data.initial_customer_code,
      response.data.initial_package_additional_repair_cost,
      response.data.initial_package_transport_cost,
      response.data.initial_package_total_repair_cost,
      response.data.initial_package_transport_ref_code,

      response.data.initial_transporter_modality,
      response.data.initial_transporter_type,
      response.data.initial_transporter_name,
      response.data.initial_expressist_transporter_id,
      response.data.initial_expressist_transporter_connexion_id,
      response.data.initial_expressist_transporter_connexion_link_id,

      response.data.tracking_number,
      response.data.with_collect,

      response.data.delivery_address_list,

      response.data.breakdown_question_list,

      response.data.product_guarantee_list,

      response.data.repairer_estimate,

      response.data.updated_at,
      response.data.created_at,

      response.data.business_created_at,
      response.data.finalization_date,

      response.data.repairer_estimate_last_relaunch_date,
      response.data.repairer_estimate_last_relaunch_date_day_count,

      response.data.estimate_package_last_relaunch_date,
      response.data.estimate_package_last_relaunch_date_day_count,

      response.data.business_created_day_count,
      response.data.takeover_by_client_date,

      response.data.deleted_date,
      response.data.deleted_day_count,

      response.data.close_date,
      response.data.close_day_count,

      response.data.leave_and_close_with_reason_date,
      response.data.leave_and_close_with_reason_day_count,

      response.data.guarantee_extension_boomerang_proof,
      response.data.guarantee_extension_boomerang_end_date,
      response.data.guarantee_extension_boomerang_id,

      response.data.initial_erp_repairer_number,

      response.data.with_erp_intern,
      response.data.erp_intern_client_id,

      response.data.prospect_document_list,
      response.data.prospect_picture_list,
      response.data.prospect_additional_info,
      response.data.prospect_repairer_email_contact,
      response.data.prospect_manufacturer_support_number,
      response.data.prospect_manufacturer_comment,
      response.data.prospect_manufacturer_choice,
      response.data.prospect_manufacturer_attachment_filename,
      response.data.prospect_manufacturer_attachment_path
    )
  }

  async close(data) {
    const response = await api.put(
      '/distributor/repair-file/close',
      data)
    return response.data
  }

  async finalizationRepairFileUpdate(repairFileId, data) {
    const response = await api.post(
      '/distributor/repair-file/finalization/' + repairFileId,
      data)
    return response.data
  }

  async getPaginatedRepairFileList(sort, order, page, limit) {
    const url = '/distributor/repair-file/list' +
      '?sort=' + sort +
      '&order=' + order +
      '&page=' + page +
      '&limit=' + limit
    const response = await api.get(url)
    return response.data
  }

  async getPaginatedRepairFileFullList(search, sort, order, page, limit, filters) {
    filters = Object.keys(filters).length !== 0 ? encodeURIComponent(JSON.stringify(filters)) : ''

    const url = '/distributor/repair-file/full-list' +
      '?search=' + encodeURIComponent(search) +
      '&sort=' + sort +
      '&order=' + order +
      '&page=' + page +
      '&limit=' + limit +
      '&filters=' + filters

    const response = await api.get(url)
    return response.data
  }

  async deleteRepairFile(data) {
    const response = await api.put(
      '/distributor/repair-file/delete',
      data)
    return response.data
  }

  async deliveredRepairFile(data) {
    const response = await api.put(
      '/distributor/repair-file-delivered',
      data)
    return response.data
  }

  async sendEstimatePackageEmailToClientWithFiles(data) {
    const response = await api.post(
      '/distributor/repair-file/send-email-estimate-package',
      data)
    return response.data
  }

  async getPaginatedRepairFileCommentList(repair_file_boomerang_id, page, limit) {
    const url = '/distributor/repair-file-comment/' +
      repair_file_boomerang_id +
      '?page=' + page +
      '&limit=' + limit
    const response = await api.get(url)
    return response.data
  }

  async createRepairFileComment(data) {
    const response = await api.post(
      '/distributor/repair-file-comment/create',
      data)
    return response.data
  }

  async getPaginatedRepairFileCustomerRecoveryList(page, limit) {
    const url = '/distributor/repair-file/customer-recovery/list' +
      '?page=' + page +
      '&limit=' + limit
    const response = await api.get(url)
    return response.data
  }

  async saveClientOptionChoice(optionSelected, token) {
    const data = {
      'optionSelected': optionSelected,
      'emailToken': token
    }

    const response = await api.post(
      '/distributor/repair-file/estimate-package/choice',
      data)
    return response.data
  }

  async saveLeaveReason(data) {
    const response = await api.post(
      '/distributor/repair-file/leave-reasons',
      data)
    return response.data
  }

  async uploadAdditionalAttachmentFile(data) {
    const response = await api.put(
      '/distributor/repair-file/upload-additional-attachment',
      data,
      {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async getAdditionalAttachmentFileList(repairFileId) {
    const response = await api.get(
      '/distributor/repair-file/additional-attachment/list/' + repairFileId)
    return response.data
  }

  async createRepairFileRepairerEstimate(data) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate/create',
      data)
    return response.data
  }

  async updateRepairFileRepairerEstimate(data) {
    const response = await api.put(
      '/distributor/repair-file/repairer-estimate/update',
      data)
    return response.data
  }

  async confirmationRepairFileRepairerEstimate(data) {
    const response = await api.put(
      '/distributor/repair-file/repairer-estimate/confirmation',
      data)
    return response.data
  }

  async createRepairFileRepairerEstimateOption(data) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate-option/create',
      data)
    return response.data
  }

  async updateRepairFileRepairerEstimateOption(data) {
    const response = await api.put(
      '/distributor/repair-file/repairer-estimate-option/update',
      data)
    return response.data
  }

  async deleteRepairFileRepairerEstimateOption(data) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate-option/delete',
      data)
    return response.data
  }

  async getRepairFileFinalizedPercent() {
    const response = await api.get('/distributor/repair-file/finalization')
    return response.data
  }

  async sendRepairFileRepairerEstimateToClient(data) {
    const response = await api.post(
      '/distributor/repair-file/send-email-repairer-estimate', data)
    return response.data
  }

  async sendNewRepairFileRepairerEstimateToClient(data) {
    const response = await api.post(
      '/distributor/repair-file/send-new-email-repairer-estimate', data)
    return response.data
  }

  async saveRepairerEstimateOptionClientChoiceFromManualSelection(data) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate/manual-selection-choice',
      data)
    return response.data
  }

  async saveRepairerEstimateOptionClientChoiceFromEmailSelection(data) {
    const response = await api.post(
      '/distributor/repair-file/repairer-estimate/email-selection-choice',
      data)
    return response.data
  }

  async relaunchCustomer(data) {
    const response = await api.put(
      '/distributor/repair-file/relaunch-customer',
      data)
    return response.data
  }

  async getAvailableRepairFileStatusUpdate(repairFileId) {
    const response = await api.get(
      '/distributor/repair-file/available-status-update/' + repairFileId)
    return response.data
  }

  async updateRepairFileStatus(repairFileId,
                               date,
                               newStatus,
                               requesterCollaboratorId) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')

    let data = {
      repairFileId: repairFileId,
      selectedDate: `${year}-${month}-${day}`,
      newStatus: newStatus,
      requesterCollaboratorId: requesterCollaboratorId
    }

    const response = await api.put(
      '/distributor/repair-file/update-status',
      data
    )
    return response.data
  }

  async updateRepairFileStatusToReceiptAtStore(repairFileId,
                                               date,
                                               newStatus,
                                               requesterCollaboratorId,
                                               clientTakeoverType,
                                               emailAddress,
                                               clientPhoneNotificationType,
                                               smsPhoneNumber) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')

    let data = {
      repairFileId: repairFileId,
      selectedDate: `${year}-${month}-${day}`,
      newStatus: newStatus,
      requesterCollaboratorId: requesterCollaboratorId,
      clientTakeoverType: clientTakeoverType,
      emailAddress: emailAddress,
      clientPhoneNotificationType: clientPhoneNotificationType,
      smsPhoneNumber: smsPhoneNumber
    }

    const response = await api.put(
      '/distributor/repair-file/update-status/receipt-at-store',
      data
    )
    return response.data
  }

  async updateRepairFileEmail(data) {
    const response = await api.put(
      '/distributor/repair-file/update-email',
      data)
    return response.data
  }

  async sendGuaranteeExtensionBoomerangByEmail(send_to, repairFileBoomerangId) {
    let data = {
      email_address: send_to,
      repair_file_boomerang_id: repairFileBoomerangId
    }

    const response = await api.post(
      '/distributor/repair-file/send-guarantee-extension-boomerang-email',
      data)
    return response.data
  }

  async updateRepairFileDepartureAddress(departureTechnicalId, addressInfos){
    const data = {
      technical_id: departureTechnicalId,
      departure_address_name: addressInfos.name,
      departure_address_number: addressInfos.number,
      departure_address_street: addressInfos.street,
      departure_address_complement_1: addressInfos.complementOne,
      departure_address_complement_2: addressInfos.complementTwo,
      departure_address_zip_code: addressInfos.zipCode,
      departure_address_city: addressInfos.city,
      departure_address_contact_name: addressInfos.contactName,
      departure_address_contact_email: addressInfos.contactEmail,
      departure_address_contact_phone_number: addressInfos.contactPhone,
      requestor_collaborator_id: $store.state.currentCollaborator.technical_id
    }

    const response = await api.post(
      '/distributor/repair-file/update-departure-address',
      data)
    return response.data
  }

  async addPurchaseOrderAttachment(data) {
    if (data instanceof FormData) {
      const response = await api.post(
        '/distributor/repair-file/repairer-estimate/add-purchase-order-attachment',
        data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } else {
      const response = await api.post(
        '/distributor/repair-file/repairer-estimate/add-purchase-order-attachment',
        data)
      return response.data
    }
  }

  async backToStepper(repairFileId) {
    const response = await api.put(
      '/distributor/repair-file/back-to-step-seven/' + repairFileId)
    return response.data
  }

  async addAttachmentFile(data) {
    const response = await api.post(
      '/distributor/repair-file/add-attachment-file',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    return response.data
  }

  async addAttachmentFileFromPublicPage(data) {
    const response = await api.post(
      '/distributor/repair-file/add-attachment-file/public',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    return response.data
  }

  async getAddAttachmentQRCodeToken(repairFileId, attachmentType, requesterCollaboratorId) {
    const response = await api.get(
      '/distributor/repair-file/add-attachment/qr-code-token/' + repairFileId
      + '?attachmentType=' + attachmentType
      + '&requesterCollaboratorId=' + requesterCollaboratorId)
    return response.data
  }

  async validateRepairFileAddAttachmentQrCodeToken(token){
    const data = {
      qr_code_token: token
    }
    const response = await api.post(
      '/distributor/repair-file/add-attachment/qr-code-token/validation', data)

    return response.data
  }

  async getUploadAdditionalAttachmentQRCodeToken(repairFileId, requesterCollaboratorId) {
    const response = await api.get(
      '/distributor/repair-file/upload-additional-attachment/qr-code-token/' + repairFileId
      + '?requesterCollaboratorId=' + requesterCollaboratorId)
    return response.data
  }

  async validateRepairFileUploadAdditionalAttachmentQrCodeToken(token){
    const data = {
      qr_code_token: token
    }
    const response = await api.post(
      '/distributor/repair-file/upload-additional-attachment/qr-code-token/validation', data)

    return response.data
  }

  async uploadAdditionalAttachmentFileFromPublicPage(data) {
    const response = await api.post(
      '/distributor/repair-file/upload-additional-attachment/public',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    return response.data
  }

  async confirmAttachmentAddedByQrCode(repairFileId, qrCodeToken, requesterCollaboratorId) {
    let data = {
      repairFileId: repairFileId,
      qrCodeToken: qrCodeToken,
      requesterCollaboratorId: requesterCollaboratorId
    }

    const response = await api.put(
      '/distributor/repair-file/add-attachment/confirm-attachment-added-by-qr-code',
      data
    )
    return response.data
  }

  async removeAttachmentFromRepairFile(repairFileId, attachmentType, requesterCollaboratorId) {
    const data = {
      'repairFileId': repairFileId,
      'attachmentType': attachmentType,
      'requesterCollaboratorId': requesterCollaboratorId
    }

    const response = await api.put(
      '/distributor/repair-file/remove-attachment',
      data
    )
    return response.data
  }

  async saveLeaveReasonAndRecycle(data) {
    const response = await api.post(
      '/distributor/repair-file/leave-reasons-and-recycle',
      data)
    return response.data
  }
}

export default new RepairFileService()
